// @flow

import React from 'react'
import styled, { css } from 'styled-components'
import Colors from 'components/styles/colors'
import { mediaMin } from 'frontend_core/dist/styles/media'
import { fontSize } from 'frontend_core/dist/styles/variables'

const H1 = styled.h1`
  color: ${Colors.black};
  font-weight: bold;
  line-height: 1.333;
  font-size: ${fontSize.medium_2}px;
  ${mediaMin.phone`
    font-size: ${props => props.fontSize || 20}px;
  `};
`

export type PropTypes = {
  children: any,
  fontSize?: number,
}

export default (props: PropTypes) => <H1>{props.children}</H1>



// WEBPACK FOOTER //
// ./src/components/atoms/Title/index.jsx